import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { authService } from '../services/authService';

export const useUserRole = () => {
    const { user } = useContext(AuthContext);
    const [role, setRole] = useState('client');
    const [loading, setLoading] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        const fetchRole = async () => {
            try {
                if (!user || !user.uid) {

                    setRole('client');
                    setIsAdmin(false);
                    setLoading(false);
                    return;
                }


                // Récupérer le rôle depuis authService
                const userRole = await authService.getUserRole(user.uid);

                setRole(userRole);
                setIsAdmin(userRole === 'admin');
            } catch (error) {
                console.error('[useUserRole] Erreur:', error);
                setRole('client');
                setIsAdmin(false);
            } finally {
                setLoading(false);
            }
        };

        fetchRole();
    }, [user, user?.uid]); // DÉPENDRE DE user.uid

    return {
        role,
        isAdmin,
        loading,
    };
};
